import React, {Fragment, useContext} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import LookWizardSection from "./lookWizard/lookWizardSection";
import {getActiveWizardItem, getAvailableSteps, getCurrentGroups} from "./lookWizard/lookWizardFunctions";
import {ROUTES} from "../../../../routes";
import {IS_PRODUCT_JOURNEY} from "../../../../config";

import GroheFeaturesHeader from "../../grohe/groheNavigation/groheFeatures/groheFeaturesHeader";
import LookWizardContext from "./lookWizard/lookWizardContext";

const LookMainWizardSections = (props) => {

  const {wizardList, location, wizardActiveStep, wizardSelectedValues, isMobile, contentHeight, wizardActiveItem,
    shopPageOpened, lookCompatabilityAlert, filtersOpened} = props;

  const showWizard = (shopPageOpened && wizardActiveItem) || (location && location.pathname && location.pathname.includes(ROUTES.wizard));

  const {isCompletedStep} = useContext(LookWizardContext);

  // console.log("showWizard", showWizard);
  if (!showWizard) {
    return null
  }

  const wizardItem = wizardActiveItem || getActiveWizardItem(wizardList, location);
  if (!wizardItem) {
    return null
  }

  const wizardSteps = getAvailableSteps(wizardItem, wizardSelectedValues);
  // console.log("wizardSteps", wizardSteps);

  const wizardSections = (
    <Fragment>
      {wizardSteps.map((wizardStep, wizardStepIndex) => {

        const shouldRenderSection = Math.abs(wizardActiveStep - wizardStepIndex) <= 1; // same as index or +1 or -1
        if (!shouldRenderSection) {
          return null;
        }

        const currentGroups = getCurrentGroups(wizardItem, wizardStepIndex, wizardSelectedValues);

        if (IS_PRODUCT_JOURNEY) {
          let classNames = "grohe-features grohe-section--wizard"
            + ((wizardActiveStep === wizardStepIndex) && !isCompletedStep ? " grohe-features--opened" : "")
            + (shopPageOpened ? " grohe-section--shop" : "");
          if (isMobile) {
            if (wizardActiveStep !== wizardStepIndex) {
              classNames += wizardActiveStep > wizardStepIndex && !isCompletedStep
                ? " lm-section--slide-left"
                : " lm-section--slide-right"
            }
          }
          return (
            <section className={classNames} key={wizardStepIndex} >
              <GroheFeaturesHeader/>
              <div className={"lm-content" + ((currentGroups.length > 1) ? "" : "  lm-content--no-scroll lm-content--product")}>
                {currentGroups.length ? <LookWizardSection wizardStep={wizardStep}
                                                           currentGroups={currentGroups}
                                                           contentHeight={contentHeight}/> : null}
              </div>
            </section>
          )
        }

        if (isMobile) {
          let classNames = "lm-content lm-content--features lm-content--wizard";
          if (wizardActiveStep !== wizardStepIndex) {
            classNames += wizardActiveStep > wizardStepIndex && !isCompletedStep
              ? " lm-section--slide-left lm-section--hidden"
              : " lm-section--slide-right lm-section--hidden"
          }
          return (
            <div className={classNames} key={wizardStepIndex}>
              {currentGroups.length ? <LookWizardSection wizardStep={wizardStep}
                                                         currentGroups={currentGroups}
                                                         contentHeight={contentHeight}/> : null}
            </div>
          )
        }
        let classNames = "lm-section lm-section--feature lw-section lm-section--slide-right";
        if (wizardActiveStep !== wizardStepIndex) {
          classNames += wizardActiveStep > wizardStepIndex && !isCompletedStep
            ? " lm-section--slide-right-more lm-section--hidden"
            : " lm-section--slide-none lm-section--hidden"
        }
        return (
          <section key={wizardStepIndex} className={classNames}>
            <div className={"lm-content" + (currentGroups.length > 1 ? "" : " lm-content--no-scroll")
              + (filtersOpened || lookCompatabilityAlert.visible ? " lm-content--slide-down" : "")}>
              {currentGroups.length ? <LookWizardSection wizardStep={wizardStep}
                                                         currentGroups={currentGroups}
                                                         contentHeight={contentHeight}/> : null}
            </div>
          </section>
        )
      })}
    </Fragment>
  )

  if (IS_PRODUCT_JOURNEY && isMobile) {
    return (
      <div className={"grohe-wizard__sections"
        + ((!wizardActiveItem || wizardActiveStep === -1 || isCompletedStep) ? " lm-section--slide-right" : "")}>
        {wizardSections}
      </div>
    )
  }

  return wizardSections

}

const mapStateToProps = (store) => {
  const {wizardList, wizardActiveStep, wizardSelectedValues, wizardActiveItem} = store.wizardState;
  const {isMobile, visualizersLoaded} = store.serverState;
  const {shopPageOpened} = store.shopState;
  const {lookCompatabilityAlert} = store.lookState;
  const {filtersOpened} = store.groheState;

  return {
    wizardList,
    wizardActiveStep,
    wizardSelectedValues,
    isMobile,
    wizardActiveItem,
    shopPageOpened,
    lookCompatabilityAlert,
    filtersOpened,
    visualizersLoadedLength: visualizersLoaded.length,
  };
};

const mapDispatchToProps = {

};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookMainWizardSections)
  )
)
